export function isLoading(stateElement) {
  return stateElement.getAttribute('data-loading') === 'true'
}

export function setLoading(stateElement, loading) {
  stateElement.setAttribute('data-loading', loading ? 'true' : 'false')
}

export function updateState(stateElement, { color, size, style }) {
  stateElement.setAttribute('data-color', color)
  stateElement.setAttribute('data-size', size)
  stateElement.setAttribute('data-style', style)
  stateElement.setAttribute('data-loading', 'false')
}

export function buildProductParams(stateElement, clickedElement) {
  const pickerType = clickedElement.dataset.pickerType
  
  const currentColor = stateElement.getAttribute('data-color')
  const currentSize = stateElement.getAttribute('data-size')
  const currentStyle = stateElement.getAttribute('data-style')
  
  const newColor = pickerType === 'color' ? clickedElement.dataset.color : currentColor
  const newSize = pickerType === 'size' ? clickedElement.dataset.size : currentSize
  const newStyle = pickerType === 'style' ? clickedElement.dataset.style : currentStyle
  
  return {
    product_line: stateElement.getAttribute('data-productline'),
    size_selected: newSize,
    color_selected: newColor,
    style_selected: newStyle,
    render_sleeving: clickedElement.dataset.render_sleeving,
  }
}
